export const waitForStateUpdate = <T>(fn: () => T): Promise<T> => {
  return new Promise(resolve => {
    const result = fn()
    requestAnimationFrame(() => {
      requestAnimationFrame(() => resolve(result))
    })
  })
}
